export enum OperationRegulationsEnum {
	PSFP = 'PSFP',
	PSI = 'PSI'
}
